(function () {
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') init();

  function init() {
    var toast = document.getElementById('eatguud-cart-toast');
    if (!toast || toast.dataset.eatguudInitialized) return;
    toast.dataset.eatguudInitialized = 'true';

    var messageEl = toast.querySelector('[data-eatguud-cart-toast-message]');
    var trackEl = toast.querySelector('[data-eatguud-cart-toast-track]');
    var fillEl = toast.querySelector('[data-eatguud-cart-toast-fill]');
    var viewCartBtn = toast.querySelector('[data-eatguud-cart-toast-view]');
    var minimumOrderAmount = parseFloat(toast.getAttribute('data-minimum-order-amount')) || 0;
    var hideTimer = null;

    function showToast() {
      fetch(window.Shopify.routes.root + 'cart.json')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var totalPrice = cart.total_price / 100;

          if (minimumOrderAmount > 0) {
            var remaining = minimumOrderAmount - totalPrice;
            if (remaining > 0) {
              messageEl.textContent =
                'Added to cart! You’re $' + remaining.toFixed(2) + ' away from our $' +
                minimumOrderAmount.toFixed(2) + ' minimum order.';
            } else {
              messageEl.textContent = 'Added to cart! You’ve met the minimum order — ready to checkout.';
            }
            var pct = Math.min(100, (totalPrice / minimumOrderAmount) * 100);
            trackEl.hidden = false;
            fillEl.style.width = pct + '%';
          } else {
            messageEl.textContent = 'Added to cart!';
            trackEl.hidden = true;
          }

          revealToast();
        })
        .catch(function () {
          messageEl.textContent = 'Added to cart!';
          trackEl.hidden = true;
          revealToast();
        });
    }

    function revealToast() {
      toast.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideToast, 5000);
    }

    function hideToast() {
      toast.classList.remove('is-visible');
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'product-form') showToast();
      });
    }

    viewCartBtn.addEventListener('click', function () {
      hideToast();
      clearTimeout(hideTimer);
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    });

    toast.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });

    toast.addEventListener('mouseleave', function () {
      hideTimer = setTimeout(hideToast, 3000);
    });
  }
})();
